module.exports = __webpack_public_path__ + "static/media/call_status_answered_hover.48fa66bb.svg";